module.exports = __webpack_public_path__ + "img/bg-2nd.9b455024.png";